import { render, staticRenderFns } from "./deleteReportCustomComponentRel.vue?vue&type=template&id=455cf9b8"
import script from "./deleteReportCustomComponentRel.vue?vue&type=script&lang=js"
export * from "./deleteReportCustomComponentRel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports